const groupPlatformsMetaTraderFields = (fields) => {
  const introFields = fields
    .filter((field) => field.key === 'title' || field.key === 'text')
    .sort((a, b) => a.sortOrder - b.sortOrder);

  const downloadGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`download-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `download-${index}-label`)) {
      break;
    }

    downloadGroups.push({ index, fields: groupFields });
  }

  return { introFields, downloadGroups };
};

export default groupPlatformsMetaTraderFields;
